/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import { FieldSlider } from '@blockly/field-slider';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

// Scheduler no bloqueante de 8 pasos con millis(), no un loop. CYCLE es un dropdown fijo 1-8 porque
// ningún board config define pines 'cycles'.
Blockly.Blocks.controls_ciclo = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_CONTROLS_CICLO_TITLE_REPEAT);
    this.appendDummyInput('PIN2').setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'],
        ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'],
      ]), 'CYCLE');
    this.appendValueInput('TIMES').setCheck(Number)
      .appendField(Blockly.Msg.LANG_CONTROLS_CICLO_TITLE_TIMES)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_CONTROLS_CICLO_MS).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendStatementInput('DO');
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_CONTROLS_CICLO_TOOLTIP);
  },
};

Blockly.Blocks.display_7_segments = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Display7segmentos.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('DATOIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_DISPLAY_7_SEGMENTS_ESCRIBIR);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_SALIDAS_DISPLAY_7_SEGMENTS).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_DISPLAY_7_SEGMENTS_TOOLTIP);
  },
};

Blockly.Blocks.display_7_segments_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Display7segmentos.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_SALIDAS_DISPLAY_7_SEGMENTS_OFF).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_DISPLAY_7_SEGMENTS_OFF_TOOLTIP);
  },
};

Blockly.Blocks.luz_peaton = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/LuzPeaton.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_PEATON_NEOPIXEL_LED);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PEATON_NEOPIXEL_LED_TOOLTIP);
  },
};

Blockly.Blocks.luz_peaton_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/LuzPeaton.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_PEATON_OFF_NEOPIXEL);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PEATON_OFF_NEOPIXEL_LED_TOOLTIP);
  },
};

Blockly.Blocks.math_counter = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendValueInput('NUM', Number)
      .appendField(Blockly.Msg.LANG_MATH_COUNTER)
      .setAlign(Blockly.inputs.Align.RIGHT)
      .setCheck(Number);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_MATH_COUNTER_SECONDS).setAlign(Blockly.inputs.Align.RIGHT);
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_MATH_COUNTER_TOOLTIP);
  },
};

// Shadow del número a mostrar en el display de 7 segmentos (0-99).
Blockly.Blocks.math_number_minmax_7segments = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new FieldSlider(0, 0, 99, 1), 'SLIDER');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_NUMBER_TOOLTIP);
  },
};

Blockly.Blocks.semaforo = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Semaforo.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'LOW'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_SALIDAS_SEMAFORO_LED).setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        ['Rojo', 'rojo'],
        ['Amarillo', 'amarillo'],
        ['Verde', 'verde'],
      ]), 'COLOR');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_SALIDAS_SEMAFORO).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        ['9 de Julio', '0'],
        ['Sarmiento', '1'],
      ]), 'CALLE')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_SEMAFORO_TOOLTIP);
  },
};

Blockly.Blocks.semaforo_giro = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/LuzGiro.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'LOW'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_SALIDAS_SEMAFORO_LED).setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        ['Rojo', 'rojo'],
        ['Verde', 'verde'],
      ]), 'COLOR');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_SALIDAS_SEMAFORO_GIRO).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_SEMAFORO_GIRO_TOOLTIP);
  },
};
